import { sanitizeOptions } from '../input-rich-text/utils/sanitize'

/* @ngInject */
function ChatMessageDirectiveController ($scope, $translate, $rootScope, $timeout, $element, $attrs, UserService, AssetService, AssetPreviewService, CommentReactionsService, ToastService, Utils) {
  const getSanitizeHtmlModule = () => import('sanitize-html')

  $scope.darkMode = $scope.darkMode || false
  $scope.isWorkflowComment = false
  $scope.isInternalApprovalComment = false
  $scope.isAssetComment = false
  $scope.isArtComment = false
  $scope.isAuthor = false
  $scope.isHover = $scope.isHover || false
  $scope.isEditable = false
  $scope.isEditing = false
  $scope.isRead = true
  $scope.reactions = null
  $scope.defaultEmojis = [
    { code: '👍', slug: 'thumbsup' },
    { code: '❤️', slug: 'heart' },
    { code: '😂', slug: 'laugh' },
    { code: '😮', slug: 'wow' },
    { code: '👎', slug: 'thumbsdown' },
    { code: '🙏', slug: 'pray' }
  ]
  $scope.selectedReaction = null

  $scope.ratingText = ''
  $scope.flags = {
    loadingAsset: false
  }
  $scope.chatMessage = {
    author: null,
    message: '',
    status: null,
    pin: null,
    assetName: '',
    type: null,
    rate: 0
  }

  const api = {
    getSanitizeHtmlModule,
    _getTaskCommentStatus,
    _handleArtComment,
    _handleTaskComment,
    _handleAssetComment,
    _setChatMessageValue,
    _getMessageReactions,
    _handleReactionTooltip,
    _getCommentType,
    _getReactionFromUser,
    _checkIfIsWorkflowComment,
    _handleLinks
  }

  this.getApi = () => api

  activate()

  function activate () {
    $scope.isWorkflowComment = api._checkIfIsWorkflowComment($scope.message.type)
    $scope.isInternalApprovalComment = $scope.message.type === 'TASK_APPROVAL_STATUS_UPDATE'
    $scope.isArtComment = Boolean($scope.message.artId)
    $scope.isAssetComment = $scope.message.type === 'ASSET_COMENT' || $scope.message.type === 'ASSET_COMMENT'

    if ($scope.isWorkflowComment) {
      api._handleTaskComment($scope.message)
    }

    if ($scope.isArtComment) {
      api._handleArtComment($scope.message)
    }

    if ($scope.isAssetComment || $scope.isInternalApprovalComment) {
      api._handleAssetComment($scope.message)
    }

    api._getMessageReactions()
  }

  $scope.$watch('message.value', (newValue) => {
    $scope.chatMessage.message = api._handleLinks(newValue)
  })

  $scope.showSeeAttachmentButton = () => {
    return $scope.chatMessage.assetId && $scope.showSeeAttachment
  }

  function _checkIfIsWorkflowComment (messageType) {
    const workflowMessageTypes = ['COMENT', 'TASK_COMMENT', 'BRIEFING_NEEDS_MODIFICATION', 'BRIEFING_REJECTED', 'BRIEFING_CANCELED', 'REVIEW_REQUIRED', 'TASK_TO_DONE', 'USER_REJECTED_DELIVERY', 'RATING']
    return workflowMessageTypes.includes(messageType)
  }

  function _handleTaskComment (message) {
    $scope.chatMessage = {
      author: message?.author,
      message: message?.value,
      status: api._getTaskCommentStatus(message.type),
      pin: message?.assetCommentPin,
      assetName: message?.asset?.name,
      assetId: message?.asset?.id,
      type: message.type,
      rate: message.rate
    }

    $scope.isAuthor = message.author.id === $rootScope.oUser.id
    $scope.isRead = true

    api._setChatMessageValue(message?.value)
  }

  function _handleArtComment (message) {
    $scope.chatMessage = {
      author: message?.user,
      message: message?.message,
      status: message.status.length && message.isActionComment ? message.status : null,
      pin: message?.pin,
      type: message.type,
      rate: message.rate
    }

    $scope.isAuthor = message.user.id === $rootScope.oUser.id
    $scope.isRead = message.hasReadComment

    api._setChatMessageValue(message?.value)
  }

  function _handleAssetComment (message) {
    $scope.chatMessage = {
      author: message?.author,
      message: message?.value,
      pin: message?.assetCommentPin,
      assetId: message?.assetId
    }

    $scope.isAuthor = message.author.id === $rootScope.oUser.id
    $scope.isRead = true

    api._setChatMessageValue(message?.value)
  }

  $scope.onHoverHandle = () => {
    $scope.isHover = true
    $scope.isEditable = $scope.isHover && $scope.isAuthor

    if ($scope.onHover) {
      $scope.onHover($scope.message)
    }
  }

  $scope.onBlurHandle = () => {
    if (!$scope.isEditing) {
      $scope.isHover = false
      $scope.isEditable = false
    }

    if ($scope.onBlur) {
      $scope.onBlur($scope.message)
    }
  }

  $scope.editMessage = () => {
    $scope.isEditing = true
    $scope.isHover = true
  }

  $scope.finishEditMessage = (editor) => {
    $scope.isEditing = false
    $scope.isHover = false
    $scope.message.value = editor.value

    api._setChatMessageValue(editor?.value)

    $scope.onEdit({
      message: $scope.message,
      newMessage: editor
    })
  }

  $scope.cancelEditMessage = () => {
    $scope.isEditing = false
    $scope.isHover = false
    api._setChatMessageValue($scope.message?.value)
  }

  $scope.deleteMessage = () => {
    $scope.onDelete($scope.message)
  }

  $scope.getAvatarUrl = (author) => {
    if (author) {
      return UserService.getUserProfileImage(author.userId)
    }

    return null
  }

  $scope.getRatingText = (rate) => {
    return $translate.instant('taskHistoryMsgs.ratedTask', { rate })
  }

  $scope.isRating = () => {
    return $scope.chatMessage.type === 'RATING' && $scope.chatMessage.rate
  }

  $scope.openAttachment = (assetId) => {
    if ($scope.showSeeAttachment && $scope.task) {
      $scope.flags.loadingAsset = true
      AssetService.getAssetDetailsById(assetId).then(asset => {
        $scope.flags.loadingAsset = false
        AssetPreviewService.openAssetPreview({
          asset: asset,
          task: $scope.task,
          location: 'workflow'
        })
      })
    }
  }

  $scope.disableActionButton = (message) => {
    return message.type === 'TASK_APPROVAL_STATUS_UPDATE'
  }

  $scope.getPinTime = (pinSeconds) => {
    const minutes = Math.floor(pinSeconds / 60).toString()
    const seconds = (pinSeconds - minutes * 60).toString()
    const finalTime = minutes.padStart(2, '0') + ':' + seconds.padStart(2, '0')

    return finalTime
  }

  function _getTaskCommentStatus (commentType) {
    const status = {
      BRIEFING_REJECTED: 'REJECTED',
      BRIEFING_NEEDS_MODIFICATION: 'WAITING_ADM_ADJUST',
      REVIEW_REQUIRED: 'REVIEW',
      TASK_TO_DONE: 'DONE'
    }

    if (status[commentType]) return status[commentType]
    return null
  }

  function _setChatMessageValue (value) {
    if (value) {
      api.getSanitizeHtmlModule().then((SanitizeHtmlModule) => {
        const sanitizeHtml = SanitizeHtmlModule.default
        const chatMessage = $element.find('[data-chat-message]')[0]

        value = api._handleLinks(value)
        chatMessage.innerHTML = sanitizeHtml(value, sanitizeOptions)
        chatMessage.innerHTML = Utils.removeNBSPSymbol(chatMessage.innerHTML)
      })
    }
  }

  $scope.getPinVersionText = () => {
    const { assetVersion, latestAssetVersion } = $scope.message
    const versionText = $translate.instant('version')

    if (!assetVersion) return $translate.instant('unavailableVersion')

    if (assetVersion === latestAssetVersion) return $translate.instant('currentVersion')

    return `${versionText} ${assetVersion}`
  }

  $scope.showReactionRow = () => {
    return $scope.reactions && Object.keys($scope.reactions).length
  }

  $scope.onReaction = (emoji) => {
    $scope.selectedReaction = $scope.selectedReaction === emoji.slug ? null : emoji.slug
    const reaction = { value: emoji.slug }
    const commentType = api._getCommentType()
    if (!commentType) return

    CommentReactionsService.createCommentReaction($scope.message.id, reaction, commentType)
      .then(() => {
        api._getMessageReactions()
        $rootScope.$emit('workflow.reloadComments')
      })
      .catch(err => console.log(err))
  }

  function _getMessageReactions () {
    const commentType = api._getCommentType()
    if (!commentType) return

    CommentReactionsService.getCommentReactionsById($scope.message.id, commentType)
      .then((reactions) => {
        $scope.reactions = reactions
        api._getReactionFromUser()
        api._handleReactionTooltip()
      })
  }

  function _handleReactionTooltip () {
    if ($scope.reactions) {
      Object.keys($scope.reactions).forEach((key) => {
        const reaction = $scope.reactions[key]
        reaction.tooltip = reaction.users.map(user => user.name).join(', ')
      })
    }
  }

  function _getCommentType () {
    if ($scope.isWorkflowComment) return 'task'
    if ($scope.isAssetComment) return 'asset'
    if ($scope.isInternalApprovalComment) return 'internal_approval'
    if ($scope.isArtComment) return 'art_approval'

    return null
  }

  function _getReactionFromUser () {
    if (!$scope.reactions) return

    const userId = $rootScope.oUser.id
    Object.keys($scope.reactions).forEach((key) => {
      const reactionUsers = $scope.reactions[key].users
      const isSelected = reactionUsers.some(user => user.id === userId)
      if (isSelected) $scope.selectedReaction = key
    })
  }

  function _handleLinks (value) {
    const formattedValue = /<p>|<\/p>|<div>|<\/div>/.test(value)
    if (formattedValue) return value

    const links = value.match(/https?:\/\/[^\s]+/g)
    if (links?.length) {
      const linksWithTags = links.map(link => `<a href="${link}" target="_blank">${link}</a>`)

      for (let i = 0; i < links.length; i++) {
        value = value.replace(links[i], linksWithTags[i])
      }
    }

    return value
  }
}

export { ChatMessageDirectiveController }
